import React from "react";

import { Router } from "./router/Router";

export const App = () => <Router />;
